export default "__VITE_ASSET__de23d33b__"